module.exports = __webpack_public_path__ + "media/images/placeholder-competitions-2d3455f2.png";